/*
    Сообщение об использовании куков
*/

class Disclaimer {
    constructor() {
        this.$container = $('.js-disclaimer');

        this.checkHistory();
        // localStorage.clear(); // debug для IE и мобильных устройств :P
    }

    bindAgree() {
        this.$container.find('.js-disclaimer-agree').on('click', () => {
            window.localStorage.setItem('cookieAgree', true);
            this.$container.hide();
        });
    }

    checkHistory() {
        if (window.localStorage.cookieAgree) {
            this.$container.hide();
        } else {
            this.bindAgree();
        }
    }
}

new Disclaimer();



// WEBPACK FOOTER //
// ./_src/js/modules/Disclaimer.js